import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { useMemo } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { isDayjs } from "dayjs";


export default function DatePropertyEditor(props: PropertyEditorProps) {
    const value = useMemo(
        () => {
            if (typeof props.value === "string" || isDayjs(props.value)) {
                return dayjs(props.value);
            }

            return null;
        },
        [props.value]
    );

    return <DatePicker
        value={value}
        onChange={(v) => {
            props.onChanged(v?.toISOString())
        }} />
}